import { ProductTileModel } from "@api/mappers/products.mapper";

import { epdmRol } from "./shared.calculation";

export const extraSurfaceArea = (
    widthA1: number,
    heightB1: number,
    lengthC2: number,
    widthW2: number,
) => {
    return (
        (widthA1 + heightB1 + lengthC2 + heightB1 + widthA1 + 20) *
        (widthA1 + heightB1 + widthW2 + 20)
    );
};

export const flexifoilSurfaceGlue = (
    lengthC1: number,
    widthW1: number,
    lengthC2: number,
    widthW2: number,
) => {
    return Math.ceil(
        ((lengthC1 - 30) * (widthW1 - 30) + (lengthC2 - 30) * (widthW2 - 30)) /
            10_000 /
            9,
    );
};

export const flexifoilBordersGlue = (
    lengthC1: number,
    widthW1: number,
    heightB1: number,
    widthA1: number,
    widthW2: number,
) =>
    Math.ceil(
        (lengthC1 * widthW1 -
            (lengthC1 - 30) * (widthW1 - 30) +
            2 * (heightB1 * lengthC1 + heightB1 * widthW1) +
            ((widthA1 + lengthC1 + widthA1) * (widthA1 + widthW1 + widthA1) -
                lengthC1 * widthW1) +
            2 * (widthW2 * 30 + widthW2 * heightB1 + widthW2 * widthA1)) /
            10_000 /
            2,
    );

export const isolationAmount = (
    lengthC1: number,
    widthW1: number,
    lengthC2: number,
    widthW2: number,
) => lengthC1 * widthW1 + lengthC2 * widthW2;

export const epmd = (
    availableDefaultSizes: Array<{
        size: number;
        product: ProductTileModel;
    }>,
    lengthC1: number,
    widthA1: number,
    lengthC2: number,
    heightB1: number,
    widthW1: number,
    widthW2: number,
) => {
    const widthRect =
        (widthA1 + heightB1 + widthW1 + heightB1 + widthA1 + 20) / 100;

    const lengthRect =
        (widthA1 + heightB1 + lengthC1 + heightB1 + widthA1 + 20) / 100;

    const widthExtra =
        (widthA1 + heightB1 + widthW2 + heightB1 + widthA1 + 10) / 100;

    const lengthExtra =
        (widthA1 + heightB1 + lengthC2 + heightB1 + widthA1 + 10) / 100;

    return [
        ...epdmRol(availableDefaultSizes, lengthRect, widthRect),
        ...epdmRol(availableDefaultSizes, lengthExtra, widthExtra),
    ];
};
